import { Datepicker } from 'vanillajs-datepicker';
import it from './it';
import bookingInitDataStorage from '../init/data-storage';
import bookingDataStorage from '../data-storage';

export default function bookCalendar(elCalendar: string = '#field_date') { 

    const elem = document.querySelector(elCalendar) as HTMLInputElement;

    if(elem === null){

        return null;

    }

    Object.assign(Datepicker.locales, it);

    const datepicker = new Datepicker(elem, {
        language : 'it',
        minDate: new Date(),
        autohide: true,
        // datesDisabled: ['2024-10-29'],
    }); 

    const modDataStorage = new bookingInitDataStorage();

    const storeInitData = modDataStorage.getLocalStorage();

    if(storeInitData !== null){
        
        // Set value
        const get_date = storeInitData?.date as unknown as string;

        if(typeof get_date !== 'undefined' && get_date !== null){

            // Set value
            datepicker.setDate(get_date);

        }

    }else{
        
        const modBookingDataStorage = new bookingDataStorage();

        const storedValues = modBookingDataStorage.getLocalStorage();

        // Set value
        const get_date = storedValues?.date_start as unknown as string | null;

        if(typeof get_date !== 'undefined' && get_date !== null){

            const date = get_date.split("T")[0];
            const parts = date.split("-");
            const finaly_date = `${parts[2]}-${parts[1]}-${parts[0]}`;

            // Set value
            datepicker.setDate(finaly_date);

        }

    }

    return datepicker;

}